
import { Component, ModelSync, Prop, Vue } from 'vue-property-decorator';
import { IKeyValuePair } from '@/models/core';

@Component
export default class OsInputSelect extends Vue {
  @ModelSync('value', 'changed', { required: true, default: '' })
  internalValue!: string;

  @Prop({ required: true, default: '' })
  label!: string;

  @Prop({ required: false, default: false })
  readonly!: string;

  @Prop({ required: true, default: [] })
  items!: IKeyValuePair<string, string>[];

  @Prop({ required: false, default: false })
  required!: boolean;

  get rules(): any {
    const rules = [];

    if (this.required) {
      rules.push((v: string) => !!v || 'Pflichtfeld');
    }

    return rules;
  }
}
